import { baseRequest } from "../axiosconfig";

// Ograničenja uvoznih fajlova (server je merodavan, ovo je samo brza provera)
export const IMPORT_MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = IMPORT_MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Provera .xlsx fajla pre slanja: bolja poruka od opšte greške servera.
 * Vraća null kad je fajl ispravan, inače tekst greške.
 */
export function validateImportFileLocally(file) {
  if (!file) return "Fajl nije izabran.";
  const ext = String(file.name || "").split(".").pop().toLowerCase();
  if (!file.name.includes(".") || ext !== "xlsx") {
    return "Uvoz radi samo sa .xlsx fajlovima. Preuzmite šablon i popunite ga.";
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return `Fajl je veći od dozvoljenih ${IMPORT_MAX_FILE_SIZE_MB} MB.`;
  }
  return null;
}

/**
 * Šalje uvozni fajl na preview ili commit rutu i vraća sadržaj `data`.
 * Content-Type se ne postavlja ručno: axios sam dodaje multipart granicu.
 */
export async function postImportFile(url, file) {
  const formData = new FormData();
  formData.append("file", file, file.name);
  const res = await baseRequest.post(url, formData);
  return res.data.data;
}

/** Prevodi greške uvoza (403/413/422/500) na tekst kao activityDocuments. */
export function importErrorMessage(error) {
  const status = error?.response?.status;
  if (status === 403) return "Nemate ovlašćenje za ovu akciju.";
  const serverMessage = error?.response?.data?.message;
  if ([413, 422, 500].includes(status) && serverMessage) return serverMessage;
  return "Provera fajla nije uspela.";
}

// Izvlači ime fajla iz Content-Disposition (kao utils/download, samo za POST)
function filenameFromHeaders(headers, fallbackName) {
  const disposition = headers?.["content-disposition"] || "";
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch (e) {
      // fallback ispod
    }
  }
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  if (plainMatch) return plainMatch[1];
  return fallbackName;
}

/**
 * Preuzima izveštaj uvoza (XLSX): redove provere, zbir i, uz naloge,
 * sheet sa privremenim lozinkama. Lozinke idu samo u ovaj fajl i u prikaz,
 * ne u localStorage ni URL.
 */
export async function downloadImportReport(payload, fallbackName = "eFUK-izvestaj-uvoza.xlsx") {
  const res = await baseRequest.post("/import/report", payload, {
    responseType: "blob",
  });
  const objectUrl = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filenameFromHeaders(res.headers, fallbackName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
  return true;
}
